import { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import SearchBar from './components/SearchBar';
import FilterPanel from './components/FilterPanel';
import BusinessGrid from './components/BusinessGrid';
import Pagination from './components/Pagination';
import Button from '../../components/ui/Button';
import BusinessMap from './components/BusinessMap';
import Icon from '../../components/AppIcon';


const BusinessDirectory = () => {
  const [businesses, setBusinesses] = useState([]);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'map'
  const [filters, setFilters] = useState({
    keyword: '',
    category: '',
    city: '',
    discountRange: '',
    rating: '',
    sortBy: 'relevance'
  });

  const itemsPerPage = 12;

  const mockUser = {
    id: 'user_001',
    type: 'user',
    name: 'Carlos Andrés Martínez',
    email: 'carlos.martinez@email.com',
    membershipTier: 'Emprendedor',
    notifications: {
      dashboard: 3,
      affiliate: 1
    }
  };

  const mockBusinesses = [
  {
    id: 'biz_001',
    name: 'Restaurante El Sabor Andino',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12bb8ee12-1768081184180.png",
    logoAlt: 'Restaurante colombiano tradicional con decoración rústica y mesas de madera',
    category: 'Restaurantes',
    discount: 25,
    rating: 4.8,
    address: 'Calle 18 #25-40, Centro, Pasto, Nariño',
    city: 'pasto',
    phone: '+57 312 456 7890',
    whatsapp: '573124567890',
    latitude: 1.2136,
    longitude: -77.2811,
    socialMedia: {
      facebook: 'https://facebook.com/elsaborandino',
      instagram: 'https://instagram.com/elsaborandino',
      twitter: ''
    }
  },
  {
    id: 'biz_002',
    name: 'Boutique Moda Elegante',
    logo: "https://images.unsplash.com/photo-1678547241895-1c307914b50c",
    logoAlt: 'Tienda de moda moderna con maniquíes exhibiendo ropa elegante y accesorios',
    category: 'Moda y Accesorios',
    discount: 30,
    rating: 4.6,
    address: 'Carrera 27 #15-32, Pasto, Nariño',
    city: 'pasto',
    phone: '+57 318 765 4321',
    whatsapp: '573187654321',
    latitude: 1.2145,
    longitude: -77.2795,
    socialMedia: {
      facebook: 'https://facebook.com/modaelegante',
      instagram: 'https://instagram.com/modaelegante',
      twitter: 'https://twitter.com/modaelegante'
    }
  },
  {
    id: 'biz_003',
    name: 'TechStore Colombia',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d409f1ef-1767401525961.png",
    logoAlt: 'Tienda de tecnología con computadoras portátiles y dispositivos electrónicos en exhibición',
    category: 'Tecnología',
    discount: 15,
    rating: 4.9,
    address: 'Avenida Panamericana #45-67, Bogotá',
    city: 'bogota',
    phone: '+57 301 234 5678',
    whatsapp: '573012345678',
    latitude: 4.7110,
    longitude: -74.0721,
    socialMedia: {
      facebook: 'https://facebook.com/techstorecol',
      instagram: 'https://instagram.com/techstorecol',
      twitter: ''
    }
  },
  {
    id: 'biz_004',
    name: 'Spa Belleza Natural',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a24d59e4-1767793851948.png",
    logoAlt: 'Spa de lujo con ambiente relajante, velas aromáticas y productos de belleza natural',
    category: 'Salud y Belleza',
    discount: 40,
    rating: 4.7,
    address: 'Calle 10 #8-15, El Poblado, Medellín',
    city: 'medellin',
    phone: '+57 315 987 6543',
    whatsapp: '573159876543',
    latitude: 6.2476,
    longitude: -75.5658,
    socialMedia: {
      facebook: 'https://facebook.com/bellezanatural',
      instagram: 'https://instagram.com/bellezanatural',
      twitter: ''
    }
  },
  {
    id: 'biz_005',
    name: 'Decoraciones Hogar Ideal',
    logo: "https://images.unsplash.com/photo-1656882927704-0fb7267861be",
    logoAlt: 'Tienda de decoración con muebles modernos, plantas y accesorios para el hogar',
    category: 'Hogar y Decoración',
    discount: 20,
    rating: 4.5,
    address: 'Carrera 5 #12-28, Cali, Valle del Cauca',
    city: 'cali',
    phone: '+57 320 456 7891',
    whatsapp: '573204567891',
    latitude: 3.4516,
    longitude: -76.5320,
    socialMedia: {
      facebook: 'https://facebook.com/hogarideal',
      instagram: 'https://instagram.com/hogarideal',
      twitter: 'https://twitter.com/hogarideal'
    }
  },
  {
    id: 'biz_006',
    name: 'Gimnasio FitLife',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed94a875-1767917630749.png",
    logoAlt: 'Gimnasio moderno con equipos de ejercicio, pesas y área de entrenamiento funcional',
    category: 'Deportes y Fitness',
    discount: 35,
    rating: 4.8,
    address: 'Avenida Libertador #30-45, Barranquilla',
    city: 'barranquilla',
    phone: '+57 311 234 5679',
    whatsapp: '573112345679',
    latitude: 10.9685,
    longitude: -74.7813,
    socialMedia: {
      facebook: 'https://facebook.com/fitlifegym',
      instagram: 'https://instagram.com/fitlifegym',
      twitter: ''
    }
  },
  {
    id: 'biz_007',
    name: 'Academia de Idiomas Global',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_17bfe8986-1767189697998.png",
    logoAlt: 'Aula de idiomas con estudiantes diversos, pizarra interactiva y materiales educativos',
    category: 'Educación',
    discount: 25,
    rating: 4.9,
    address: 'Calle 8 #4-56, Centro Histórico, Cartagena',
    city: 'cartagena',
    phone: '+57 314 567 8901',
    whatsapp: '573145678901',
    latitude: 10.3910,
    longitude: -75.4794,
    socialMedia: {
      facebook: 'https://facebook.com/academiaglobal',
      instagram: 'https://instagram.com/academiaglobal',
      twitter: 'https://twitter.com/academiaglobal'
    }
  },
  {
    id: 'biz_008',
    name: 'Cine Entretenimiento Plus',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_19c4ddec4-1767700310869.png",
    logoAlt: 'Sala de cine moderna con butacas reclinables rojas y pantalla grande',
    category: 'Entretenimiento',
    discount: 30,
    rating: 4.6,
    address: 'Centro Comercial Ventura, Cúcuta',
    city: 'cucuta',
    phone: '+57 317 890 1234',
    whatsapp: '573178901234',
    latitude: 7.8939,
    longitude: -72.5078,
    socialMedia: {
      facebook: 'https://facebook.com/cineplus',
      instagram: 'https://instagram.com/cineplus',
      twitter: ''
    }
  },
  {
    id: 'biz_009',
    name: 'Consultoría Empresarial Pro',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6d75657-1766483971279.png",
    logoAlt: 'Oficina profesional con equipo de consultores en reunión estratégica con gráficos',
    category: 'Servicios Profesionales',
    discount: 20,
    rating: 4.7,
    address: 'Torre Empresarial, Piso 12, Bucaramanga',
    city: 'bucaramanga',
    phone: '+57 319 012 3456',
    whatsapp: '573190123456',
    latitude: 7.1193,
    longitude: -73.1227,
    socialMedia: {
      facebook: 'https://facebook.com/consultoriapro',
      instagram: 'https://instagram.com/consultoriapro',
      twitter: 'https://twitter.com/consultoriapro'
    }
  },
  {
    id: 'biz_010',
    name: 'Taller Automotriz Express',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1312b2115-1764643783412.png",
    logoAlt: 'Taller mecánico profesional con vehículos en servicio y herramientas especializadas',
    category: 'Automotriz',
    discount: 15,
    rating: 4.5,
    address: 'Avenida 30 de Agosto #25-30, Pereira',
    city: 'pereira',
    phone: '+57 321 345 6789',
    whatsapp: '573213456789',
    latitude: 4.8087,
    longitude: -75.6906,
    socialMedia: {
      facebook: 'https://facebook.com/tallerexpress',
      instagram: 'https://instagram.com/tallerexpress',
      twitter: ''
    }
  },
  {
    id: 'biz_011',
    name: 'Café Aroma Colombiano',
    logo: "https://images.unsplash.com/photo-1505985860171-50cdd8616e7d",
    logoAlt: 'Cafetería acogedora con granos de café, máquina espresso y ambiente cálido',
    category: 'Restaurantes',
    discount: 20,
    rating: 4.8,
    address: 'Calle Real #15-20, Manizales, Caldas',
    city: 'manizales',
    phone: '+57 316 789 0123',
    whatsapp: '573167890123',
    latitude: 5.0703,
    longitude: -75.5138,
    socialMedia: {
      facebook: 'https://facebook.com/aromacolombia',
      instagram: 'https://instagram.com/aromacolombia',
      twitter: ''
    }
  },
  {
    id: 'biz_012',
    name: 'Zapatería Paso Firme',
    logo: "https://images.unsplash.com/photo-1628846761280-1dae09155e4c",
    logoAlt: 'Zapatería moderna con exhibición de calzado deportivo y casual en estantes organizados',
    category: 'Moda y Accesorios',
    discount: 35,
    rating: 4.6,
    address: 'Centro Comercial Unicentro, Pasto',
    city: 'pasto',
    phone: '+57 313 456 7892',
    whatsapp: '573134567892',
    latitude: 1.2150,
    longitude: -77.2800,
    socialMedia: {
      facebook: 'https://facebook.com/pasofirme',
      instagram: 'https://instagram.com/pasofirme',
      twitter: 'https://twitter.com/pasofirme'
    }
  },
  {
    id: 'biz_013',
    name: 'Electrónica Digital Store',
    logo: "https://images.unsplash.com/photo-1719789954439-cd9e785688bd",
    logoAlt: 'Tienda de electrónica con smartphones, tablets y accesorios tecnológicos en vitrinas',
    category: 'Tecnología',
    discount: 25,
    rating: 4.7,
    address: 'Carrera 13 #52-30, Bogotá',
    city: 'bogota',
    phone: '+57 302 567 8903',
    whatsapp: '573025678903',
    latitude: 4.7110,
    longitude: -74.0721,
    socialMedia: {
      facebook: 'https://facebook.com/digitalstore',
      instagram: 'https://instagram.com/digitalstore',
      twitter: ''
    }
  },
  {
    id: 'biz_014',
    name: 'Salón de Belleza Glamour',
    logo: "https://images.unsplash.com/photo-1560066984-138dadb4c035",
    logoAlt: 'Salón de belleza elegante con sillas de estilista, espejos iluminados y productos profesionales',
    category: 'Salud y Belleza',
    discount: 30,
    rating: 4.9,
    address: 'Calle 33 #70-25, Laureles, Medellín',
    city: 'medellin',
    phone: '+57 318 901 2345',
    whatsapp: '573189012345',
    latitude: 6.2476,
    longitude: -75.5658,
    socialMedia: {
      facebook: 'https://facebook.com/salonglamour',
      instagram: 'https://instagram.com/salonglamour',
      twitter: ''
    }
  },
  {
    id: 'biz_015',
    name: 'Mueblería Casa Confort',
    logo: "https://images.unsplash.com/photo-1627890967379-0acb771b0074",
    logoAlt: 'Mueblería con sala de exhibición de sofás, mesas y decoración para el hogar',
    category: 'Hogar y Decoración',
    discount: 40,
    rating: 4.5,
    address: 'Avenida 6N #23-50, Cali',
    city: 'cali',
    phone: '+57 315 012 3457',
    whatsapp: '573150123457',
    latitude: 3.4516,
    longitude: -76.5320,
    socialMedia: {
      facebook: 'https://facebook.com/casaconfort',
      instagram: 'https://instagram.com/casaconfort',
      twitter: 'https://twitter.com/casaconfort'
    }
  }];


  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setBusinesses(mockBusinesses);
      setFilteredBusinesses(mockBusinesses);
      setLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, businesses]);

  const applyFilters = () => {
    let filtered = [...businesses];

    if (filters?.keyword) {
      const keyword = filters?.keyword?.toLowerCase();
      filtered = filtered?.filter(
        (business) =>
        business?.name?.toLowerCase()?.includes(keyword) ||
        business?.category?.toLowerCase()?.includes(keyword) ||
        business?.address?.toLowerCase()?.includes(keyword)
      );
    }

    if (filters?.category) {
      filtered = filtered?.filter(
        (business) => business?.category?.toLowerCase() === filters?.category?.toLowerCase()
      );
    }

    if (filters?.city) {
      filtered = filtered?.filter((business) => business?.city === filters?.city);
    }

    if (filters?.discountRange) {
      const [min, max] = filters?.discountRange?.split('-')?.map((v) => v === '+' ? 100 : parseInt(v));
      filtered = filtered?.filter((business) => {
        if (max) {
          return business?.discount >= min && business?.discount <= max;
        }
        return business?.discount >= min;
      });
    }

    if (filters?.rating) {
      const minRating = parseFloat(filters?.rating);
      filtered = filtered?.filter((business) => business?.rating >= minRating);
    }

    switch (filters?.sortBy) {
      case 'discount-high':
        filtered?.sort((a, b) => b?.discount - a?.discount);
        break;
      case 'discount-low':
        filtered?.sort((a, b) => a?.discount - b?.discount);
        break;
      case 'rating':
        filtered?.sort((a, b) => b?.rating - a?.rating);
        break;
      case 'newest':
        filtered?.reverse();
        break;
      case 'proximity':
        break;
      default:
        break;
    }

    setFilteredBusinesses(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (searchFilters) => {
    setFilters((prev) => ({ ...prev, ...searchFilters }));
  };

  const handleFilterChange = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const handleAdvancedFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const totalPages = Math.ceil(filteredBusinesses?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBusinesses = filteredBusinesses?.slice(startIndex, endIndex);

  const paginatedBusinesses = currentBusinesses;

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} />
      <div className="container mx-auto px-4 py-6">
        <NavigationBreadcrumbs
          items={[
          { label: 'Inicio', path: '/' },
          { label: 'Directorio de Negocios', path: '/business-directory' }]
          } />


        <SearchBar
          onSearch={handleSearch}
          onFilterChange={handleFilterChange}
          resultsCount={filteredBusinesses?.length} />


        {/* View mode toggle */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-foreground">
            {viewMode === 'grid' ? 'Negocios Registrados' : 'Mapa de Negocios'}
          </h2>
          <div className="flex gap-2">
            <Button
              variant={viewMode === 'grid' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setViewMode('grid')}
              iconName="Grid"
              iconPosition="left">

              Vista de cuadrícula
            </Button>
            <Button
              variant={viewMode === 'map' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setViewMode('map')}
              iconName="Map"
              iconPosition="left">

              Vista de mapa
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Desktop filters */}
          <div className="hidden lg:block">
            <FilterPanel onFilterChange={handleAdvancedFilters} />
          </div>

          {/* Main content */}
          <div className="lg:col-span-3">
            {viewMode === 'grid' ?
            <>
                {loading ?
              <div className="flex items-center justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                  </div> :

              <>
                    <BusinessGrid businesses={paginatedBusinesses} loading={loading} />
                    <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange} />

                  </>
              }
              </> :

            <BusinessMap
              businesses={filteredBusinesses}
              selectedCategory={filters?.category}
              onBusinessSelect={(business) => {
                // Optional: scroll to business card or show details
                console.log('Selected business:', business);
              }} />

            }
          </div>
        </div>

        {/* Mobile filter button */}
        <button
          onClick={() => setShowMobileFilters(true)}
          className="lg:hidden fixed bottom-6 right-6 bg-primary text-primary-foreground p-4 rounded-full shadow-lg z-50"
          aria-label="Abrir filtros">

          <Icon name="SlidersHorizontal" size={24} />
        </button>

        {/* Mobile filters modal */}
        {showMobileFilters &&
        <FilterPanel
          onFilterChange={handleAdvancedFilters}
          isMobile={true}
          onClose={() => setShowMobileFilters(false)} />

        }
      </div>
    </div>);

};

export default BusinessDirectory;